import { defineStore, getActivePinia, } from 'pinia'
import fetch from '@/assets/js/src/util/fetch'
import { checkResponse, handleException, } from '@/assets/js/src/util/apiTools'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { useBibleStore, } from '@/assets/js/src/modules/bible/_pinia/bible'

const API_GET_SYNOPTIC = '/api/synoptic'

export const useSynopticStore = defineStore('synoptic', {
    state: () => ({
        synoptic: {},
        reload: false,
    }),
    actions: {
        async getSynoptic ({ abbr, id, }) {
            let activePinia = getActivePinia()
            let bibleStore = useBibleStore(activePinia)

            try {
                let useCache = true

                // Api-Request senden
                let apiResponse = await fetch({
                    url: `${API_GET_SYNOPTIC}/${bibleStore.getAbbrByAbbreviation(abbr)}/${id}`,
                    options: {
                        headers: getDefaultHeaders({
                            useCache,
                        }),
                    },
                    useCache,
                    tags: [
                        'synoptic',
                        `bible.${abbr}`,
                    ],
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                this.synoptic = apiResponse.data

            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, true)
            }
        },
    },
})
